import classNames from 'classnames';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  interestList,
  toggleItemInList,
} from '@/modules/auth/components/FormsContainer/CreateCompany/logic';
import { Checkbox, Typography } from '@/shared/components/atoms';

function StepThree() {
  const { t } = useTranslation('login');
  const { control, watch, trigger } = useFormContext();
  const interestWatcher = watch('featuresOfInterest');

  return (
    <div className='flex flex-col gap-2'>
      <Controller
        control={control}
        name='featuresOfInterest'
        render={({ field: { onChange } }) => (
          <div className='grid grid-cols-1 gap-2'>
            {interestList.map((interest) => {
              const isActive = interestWatcher?.includes(interest.name);
              return (
                <div
                  key={interest.id}
                  className={classNames(
                    'flex cursor-pointer items-center gap-2 rounded-xl border-xs px-12 py-2',
                    isActive
                      ? 'border-blue-100 bg-surface-0'
                      : 'border-neutralVariant-90 bg-white'
                  )}
                  onClick={() => {
                    const newValue = toggleItemInList(
                      interestWatcher ?? [],
                      interest.name
                    );
                    onChange(newValue);
                    trigger('featuresOfInterest');
                  }}
                >
                  <Checkbox value={interest.name} checked={isActive} />
                  <Typography
                    variant='body2'
                    weight='semiBold'
                    className={classNames(
                      isActive ? 'text-primary-20' : 'text-text-default'
                    )}
                  >
                    {t(interest.name)}
                  </Typography>
                </div>
              );
            })}
          </div>
        )}
      />
      {/* TODO: if other selected then show input field */}
    </div>
  );
}

export { StepThree };
